'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:share:disableNavButton');
}

var _invoke = require('../invoke');

/**
 * share.disableNavButton 禁用导航栏分享按钮
 *
 * 支持版本
 * + iHotel/7.0+
 *
 * @memberof share
 * @static
 * @name disableNavButton
 * @return {Undefined}
 * @example
 *  hbnb.share.disableNavButton();
 */

module.exports = function() {
	if (process.env.NODE_ENV !== 'production') {
        debug('called');
    }
    var p = new Promise(function(resolve, reject) {
    	_invoke('share', 'disable_nav_share_button', {});
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/share/disable-nav-button.js
// module id = 613
// module chunks = 0